const menu = {
    label: 'Impressoras',
    icon: 'pi pi-fw pi-print',
    rules: ['CHECKINS-EVENTOS-15'],
    items: [
        {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-chart-bar',
            to: '/checkins/impressoras/dashboard',
            rules: ['CHECKINS-EVENTOS-15'],
        },
    ],
};

export default menu;
